











































































































import {
  Vue, Component, Prop, Emit, Watch,
} from 'vue-property-decorator';
import ModalComponent from '@/shared/modal/modal.component.vue';
import ModalOptions from '@/shared/modal/modal-options.entity';
import ContractService from '@/domain/contract/service/contract.service';
import LabelSlot from '@/shared/slots/label-slot.component.vue';
import Pagination from '@/domain/pagination.entity';
import DateHandler from '@/shared/utils/date-format';
import ModalWarning from '@/shared/modal/modal-warning.component.vue';
import { VbPagination } from '@/shared/pagination/pagination.component.vue';
import { VbSnackbarService } from '@/shared/snackbar/snackbar.service';
import { VbTooltipSlot } from '@/shared/slots/tooltip-slot.component.vue';
import toDocument from '@/shared/directive/toDocument';
import FilterComponent from './contract-modal-filter.component.vue';
import Header from './header.json';
import ContractList from '../../../domain/contract/entity/contract-list.entity';
import ContractFilter from '../../../domain/contract/entity/contract-filter.entity';
import Response from '../../../domain/response.entity';

@Component({
  components: {
    ModalComponent, LabelSlot, VbPagination, VbTooltipSlot, FilterComponent, ModalWarning,
  },
  filters: {
    formatDate(value: string) {
      return DateHandler.timestampToLocal(value);
    },
    toDocument,
  },
})

export default class ContractModal extends Vue {
  @Prop({ required: true })
  show!: boolean;

  @Prop({ required: true })
  businessUnitId!: string;

  @Emit('cancel')
  private cancel(): void {}

  warningMessage: string = 'Deseja realmente prosseguir? Ao clicar no botão Sim, as instâncias serão imediatamentes vinculadas ao contrato selecionado.';

  warningModal: boolean = false;

  valid: boolean = false;

  ref: any = this.$refs.ref;

  selectedContractId = '';

  closeWarningModal() {
    this.warningModal = false;
  }

  get options(): ModalOptions {
    return {
      title: 'Selecione o contrato para vinculo',
      titleAlign: 'center',
      showClose: false,
      showOk: false,
      labelOk: 'Salvar',
      okColor: 'bluePrimary',
      showCancel: true,
      labelCancel: 'Cancelar',
      width: 1280,
      persistent: true,
      disabledOk: !this.valid,
    }
  }

  showFilter: boolean = false;

  header = Header;

  filter: ContractFilter = new ContractFilter({ status: 'ACTIVE' });

  pagination: Pagination = new Pagination({
    page: 0,
    itemsPerPage: 10,
    sortBy: [],
    defaultSort: 'customer.name|asc',
  });

  contracts: ContractList[] = [];

  inconsistentContractMessage = `Contrato não possui cálculo configurado
   ou instância cadastrada ou data de início de faturamento ou o contrato é uma prévia.`;

  selectContract(value: string) {
    this.selectedContractId = value;
    this.warningModal = true;
  }

  handleConfirm() {
    this.warningModal = false;
    this.$emit('contractSelected', this.selectedContractId);
    this.cancel();
  }

  checkAndApplyUrlFilter(): void {
    if (this.$route.params.status) {
      const filter: ContractFilter = new ContractFilter(
        { status: this.$route.params.status.toUpperCase() },
      );
      this.applyFilter(filter);
    }
  }

  created() {
    this.findContracts(this.filter);
  }

  applyFilter(filter: ContractFilter) {
    this.$route.params.status = filter.status;
    this.filter = ContractFilter.of(filter);
    this.filter.prepareToSend();
    this.pagination.page = 1;
    this.findContracts(this.filter);
  }

  findContracts(filter: ContractFilter) {
    if (this.businessUnitId) {
      ContractService.filter(this.pagination, this.businessUnitId, filter)
        .then((response: Response) => {
          this.contracts = ContractList.ofList(response.content)
          this.pagination.total = response.totalElements;
          this.pagination.pageCount = response.totalPages;
        })
        .catch((err: any) => VbSnackbarService.handleHttpError(err));
    }
  }

  updateTable(pagination: Pagination) {
    this.pagination.verifyPage();
    this.findContracts(this.filter);
  }

  get menuIcon(): string {
    return this.showFilter ? 'mdi-filter' : 'mdi-filter-outline'
  }
}

